import * as types from './types';
export default {
  [types.SET_DESCRIPTION](state, payload) {
    var currentState = state;
    currentState.description = payload;
  },

  [types.RESET_SEARCH](state) {
    var currentState = state;
    currentState.total = null;
    currentState.products = null;
    currentState.description = null;
  },

  [types.SET_PRODUCTS](state, _ref) {
    var {
      products,
      total
    } = _ref;
    var currentState = state;
    currentState.total = total;
    currentState.products = products;
  },

  [types.APPEND_PRODUCTS](state, payload) {
    var currentState = state;
    var products = currentState.products.map(e => Object.assign(e, {
      old: true
    }));
    currentState.products = [...products, ...payload];
  },

  [types.PREPEND_PRODUCTS](state, payload) {
    var currentState = state;
    var products = currentState.products.map(e => Object.assign(e, {
      old: true
    }));
    currentState.products = [...payload, ...products];
  }

};